.ItemBreakdown {
  left: -6em;
  right: -6em;
  z-index: 110;
  position: absolute;
}
.ItemBreakdown .Contents {
  width: 16em;
  margin: auto;
  font-size: 1.25rem;
  position: relative;
  border-style: solid;
  border-width: 0.3em;
  border-radius: 0.25em;
  border-color: #111111;
  background-color: #e7e7e7;
  color: #111111;
  font-family: var(--editor-font);
  overflow: hidden;
  pointer-events: none;
}
.ItemBreakdown .Contents .Icon {
  top: 0.4em;
  right: 0.4em;
  width: 3em;
  height: 3em;
  position: absolute;
  opacity: 0.3;
  mix-blend-mode: multiply;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.ItemBreakdown .Contents .Summary {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 0.809em;
  padding-right: 0.809em;
}
.ItemBreakdown .Contents .Summary .Title {
  font-size: 1.4em;
  font-weight: bold;
  text-decoration: underline;
}
.ItemBreakdown .Contents .KeywordDefinition {
  opacity: 0.5;
  mix-blend-mode: multiply;
  font-style: italic;
  padding-left: 0.809em;
  padding-right: 0.809em;
  padding-bottom: 0.5em;
  display: none;
}
.ItemBreakdown .Contents .KeywordDefinition[hasKeyword] {
  display: block;
}
.ItemBreakdown .Contents .KeywordDefinition .Text {
  font-size: 0.75em;
}
.ItemBreakdown .Contents .Flavor {
  opacity: 0.5;
  mix-blend-mode: multiply;
  font-style: italic;
  padding-left: 0.809em;
  padding-right: 0.809em;
  padding-bottom: 0.5em;
  display: none;
}
.ItemBreakdown .Contents .Flavor[hasFlavor] {
  display: block;
}
.ItemBreakdown .Contents .Flavor .Text {
  font-size: 0.5em;
}
.ItemBreakdown .Contents .Elements {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 0.809em;
  padding-right: 0.809em;
  display: none;
}
.ItemBreakdown .Contents .Elements[hasElement] {
  display: block;
}
.ItemBreakdown .Contents .Elements[element=fire] {
  background: linear-gradient(180deg, #e7e7e7 0%, #d54b33 100%);
}
.ItemBreakdown .Contents .Elements[element=earth] {
  background: linear-gradient(180deg, #e7e7e7 0%, #62C370 100%);
}
.ItemBreakdown .Contents .Elements[element=water] {
  background: linear-gradient(180deg, #e7e7e7 0%, #639bff 100%);
}
.ItemBreakdown .Contents .Elements .Effectiveness,
.ItemBreakdown .Contents .Elements .Ineffectiveness {
  font-size: 0.75em;
}
.ItemBreakdown .Contents .Keyword {
  font-weight: bold;
  position: relative;
}
.ItemBreakdown .Contents .Keyword[link]::after {
  content: "";
  width: 95%;
  height: 1px;
  left: 0em;
  right: 0em;
  bottom: 0em;
  margin: auto;
  position: absolute;
  border-bottom-width: 0.15em;
  border-bottom-style: dotted;
  border-bottom-color: #111111;
}
.ItemBreakdown .Contents .fire,
.ItemBreakdown .Contents [element=fire] {
  color: #732e22;
}
.ItemBreakdown .Contents .fire[link]::after,
.ItemBreakdown .Contents [element=fire][link]::after {
  border-bottom-color: #732e22;
}
.ItemBreakdown .Contents .earth,
.ItemBreakdown .Contents [element=earth] {
  color: #3a6a41;
}
.ItemBreakdown .Contents .earth[link]::after,
.ItemBreakdown .Contents [element=earth][link]::after {
  border-bottom-color: #3a6a41;
}
.ItemBreakdown .Contents .water,
.ItemBreakdown .Contents [element=water] {
  color: #3a5688;
}
.ItemBreakdown .Contents .water[link]::after,
.ItemBreakdown .Contents [element=water][link]::after {
  border-bottom-color: #3a5688;
}
